"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractUpdatedPropertiesFromMongoModifier = void 0;
function extractUpdatedPropertiesFromMongoModifier(modifier) {
    const updatedProperties = new Set();
    const modifierProps = ['$set', '$unset', '$push', '$pull', '$addToSet', '$pullAll', '$pushAll', '$pop', '$inc'];
    modifierProps.forEach(prop => {
        if (modifier[prop]) {
            Object.keys(modifier[prop]).forEach(key => {
                let updatedPropertyKey = key;
                if (key.includes('.$')) {
                    // If we modify several elements of an array, we only want to know the array has been modified
                    updatedPropertyKey = key.split('.$')[0];
                }
                updatedProperties.add(updatedPropertyKey);
            });
        }
    });
    return Array.from(updatedProperties);
}
exports.extractUpdatedPropertiesFromMongoModifier = extractUpdatedPropertiesFromMongoModifier;
//# sourceMappingURL=extractUpdatedPropertiesFromMongoModifier.js.map